// extracted by mini-css-extract-plugin
module.exports = {"background":"_1WB5sbn","icon":"_15F8l_i"};